import { useAppStore } from "./store/useAppStore";

import { setTourErrorInfoSelector } from "./store/setters";

import { setActiveSceneErrorSelector } from "./store/setters";
import { setHotspotActiveIndexSelector } from "./store/setters";
import { setTourSceneHotspotErrorSelector } from "./store/setters";
import { createTourSelector } from "./store/getters";
import TourRules from "../helpers/TourRules";
import * as errorMessageConstans from '../helpers/ErrorMessageConstants'
import { setTourErrorActiveSceneIndexSelector } from "./store/setters";



export const useValidateForm = () => {

    const setActiveSceneError = useAppStore(setActiveSceneErrorSelector);
    const setHotspotActiveIndex = useAppStore(setHotspotActiveIndexSelector);
    const setTourSceneNewHotspotError = useAppStore(setTourSceneHotspotErrorSelector);
    const setTourErrorInfo = useAppStore(setTourErrorInfoSelector);
    const createTourObj = useAppStore(createTourSelector);
    const setTourErrorActiveSceneIndex = useAppStore(setTourErrorActiveSceneIndexSelector);
    
    const { 
      info: tourInfoRules,
      scene : tourSceneRules,
      hotspot: tourHotspotRules,
      hotspotMove: tourHotspotMoveRule,
      tourPoster: tourPosterRules,
      scenePanoImage: tourScenePanoImageRules
    } = TourRules;
    
    let infoFormValid = true;
    let sceneFormValid = true;
    let hotspotFormValid = true;
    const tourInfoKeys = Object.keys(createTourObj.info);
    const tourPosterKeys = Object.keys(createTourObj.info.tourPoster);

    // console.log('object',createTourObj);
    
    const validate = () => {
      
      //Tour info validation
        tourInfoKeys.forEach( key => {
          if (tourInfoRules[key]) {   
            validateTourInfo({name:key,value:createTourObj.info[key]})
          } 
        }); 
        //Tour poster validation
        tourPosterKeys.forEach((key) => {
          validateTourposter({ key, value:createTourObj.info.tourPoster[key]})
        })
        //Tour scene length validation
        if(createTourObj.scenes.length === 0){
          infoFormValid = false;
          setTourErrorInfo({ scene: errorMessageConstans["scene"] });
        }

        //scenes validation
        createTourObj.scenes.forEach((scene,index) => {
          setTourErrorActiveSceneIndex(index);
            const sceneKeys = Object.keys(scene);
            sceneKeys.forEach((key,indx) => {
                validateScene({name:key,value:scene[key]});
            })

            tourPosterKeys.forEach((key) => {
              validateScenePano({ key,value:scene.panoImage[key] })
            })
            
            scene.hotspots.forEach((hotspot,index) => {
              setHotspotActiveIndex(index);
              const { hotspotType } = hotspot;
              const hotspotKeys = Object.keys(hotspot);
              hotspotKeys.forEach((key, index) => {
              setTourSceneNewHotspotError({ [key]: "" });
              validateHotspot({ key,value:hotspot[key], hotspotType });
              })
            })
          });

      if(infoFormValid && sceneFormValid && hotspotFormValid) {
        return true;
      }
      
      return false;
    }


    const validateTourInfo = (props) => {
        const { name, value } = props;
        if(tourInfoRules[name]) {
            tourInfoRules[name].forEach(rule => {
                const valid =  rule(value);
                if(!valid) {
                    setTourErrorInfo({ [name]: errorMessageConstans[name] });
                } else  {
                    setTourErrorInfo({ [name]: "" });
                } 
            })
        }
    }

    const validateTourposter = (props) => {
      const { key, value } = props;
       if(tourPosterRules[key]) {
        const posterRules = tourPosterRules[key];
          posterRules.forEach(rule => {
              const valid = rule(value);
              if (!valid) {
                  let errorName = 'poster'+key;
                  setTourErrorInfo({ [key]: errorMessageConstans[errorName] });
                  infoFormValid = false;
              } else {
                setTourErrorInfo({ [key]: "" });
              } 
          })
        }
    }

    const validateScene = (props) => {
      const { name, value } = props;
        if(tourSceneRules[name]) {
          tourSceneRules[name].forEach(rule => {
              const valid =  rule(value);        
              if(!valid) {
                let errorName = 'scene'+name;
                setActiveSceneError({ [name]: errorMessageConstans[errorName] })
              } else  {
                setActiveSceneError({ [name]: "" })
              } 
          })
        }
    }

    const validateScenePano = (props) => {
      const { key, value } = props;
      if(tourPosterRules[key]) {
        const panoImageRules = tourScenePanoImageRules[key];
        panoImageRules.forEach(rule => {
              const valid = rule(value);
              if (!valid) {
                let errorName = 'scene'+key;
                  setActiveSceneError({ url: errorMessageConstans[errorName] })
                  infoFormValid = false;
              } else  {
                setActiveSceneError({ url: "" })
              } 
          })
      }
    }

    const validateHotspot = (props) => {
      const { key, value, hotspotType }  = props;
      if(tourHotspotRules[key] && hotspotType === 'data') {
        const hotspotRules = tourHotspotRules[key];
        hotspotRules.forEach(rule => {
          const valid = rule(value);
              if(!valid) {
                let errorName = 'hotspot'+key;
                setTourSceneNewHotspotError({ [key]: errorMessageConstans[errorName] });
                hotspotFormValid = false;
              } else {
                setTourSceneNewHotspotError({ [key]: "" });
              }
        })
      } else if(tourHotspotMoveRule[key] && hotspotType === 'move') {
        const hotspotRules = tourHotspotMoveRule[key];
        hotspotRules.forEach(rule => {
        const valid = rule(value);
            if(valid) { 
              setTourSceneNewHotspotError({ [key]: "" });
            } else {
              let errorName = 'hotspot'+key;
              setTourSceneNewHotspotError({ [key]: errorMessageConstans[errorName] });
              hotspotFormValid = false;
            }
          })
      }
      return hotspotFormValid;
  }


  return { 
    validate, 
    validateTourInfo, 
    validateTourposter, 
    validateScene, 
    validateScenePano,
    validateHotspot 
  } ;
}
  